import React, {Component} from 'react';
import {connect, DispatchProp} from "react-redux";
import {IApplicationState} from "../store";
import {AppScene} from "../store/routing/AppScene";
import MainMenuScene from "./main-menu/MainMenuScene";
import LevelMapScene from "./level-map/LevelMapScene";
import QuestionScene from "./question/QuestionScene";
import LevelSelectionScene from "./level-selection/LevelSelectionScene";
import styles from "./layout.module.css";
import HistoryScene from "./history/HistoryScene";
import ProfileScene from "./profile/ProfileScene";
import ChestMiniGameScene from "./chest-mini-game/ChestMiniGameScene";
import CardsMiniGameScene from "./cards-mini-game/CardsMiniGameScene";
import LoadingScreen from "../shared/components/loading/LoadingScreen";
import DialogManager from "../shared/components/dialog-manager/DialogManager";
import LevelCompletedScene from "./level-completed/LevelCompletedScene";
import {ICanvasDimensions} from "../store/settings/types";
import LeaderboardsScene from "./leaderboards/LeaderboardsScene";
import {iif} from "../shared/components/iif";
import {Overlay} from "../shared/components/overlay/Overlay";
import StoreScene from "./store/StoreScene";
import {TweenLite} from "gsap";
import { cssHelper } from '../shared/utils/cssHelper';

interface AppProps {
    adIsShowing: boolean;
    canvas: ICanvasDimensions;
    currentScene?: AppScene;
}

class App extends Component<AppProps & DispatchProp> {
    private readonly hostElement: React.RefObject<HTMLDivElement> = React.createRef();

    render() {
        const scene = this.renderCurrentScene();
        const {width, height, scaleFactor} = this.props.canvas;

        return (<div ref={this.hostElement} className={cssHelper(styles.canvas).add('scale-2x', scaleFactor <= 0.6).toString()} style={{ width: width, height: height, transform: `scale(${scaleFactor}) translateX(-50%)` }}>
            {scene}
            <DialogManager/>
            <LoadingScreen/>
            {iif(this.props.adIsShowing, <Overlay opacity={1} zIndex={10001}/>)}
        </div>)
    }

    componentDidMount(): void {
        if (!this.hostElement.current)
            return;

        TweenLite.from(this.hostElement.current, 0.5, {
            opacity: 0
        });
    }

    private renderCurrentScene() {
        switch (this.props.currentScene) {
            case 'MainMenu': return <MainMenuScene />;
            case 'LevelSelection': return <LevelSelectionScene />;
            case 'LevelMap': return <LevelMapScene />;
            case 'LevelCompleted': return <LevelCompletedScene />;
            case 'Question': return <QuestionScene />;
            case 'Profile': return <ProfileScene />;
            case 'History': return <HistoryScene />;
            case 'ChestMiniGame': return <ChestMiniGameScene />;
            case 'CardsMiniGame': return <CardsMiniGameScene />;
            case 'Leaderboards': return <LeaderboardsScene />;
            case 'Store': return <StoreScene />;
        }
    }
}

export default connect(({ routing, settings, advertisement, payments }: IApplicationState) => ({
    canvas: settings.canvas,
    currentScene: routing.scene,
    adIsShowing: advertisement.adIsShowing,
}))(App);